export default "__VITE_ASSET__aMk1E4B3__"